import { render, staticRenderFns } from "./TeacherLevelForm.vue?vue&type=template&id=4656ae4f&scoped=true&"
import script from "./TeacherLevelForm.vue?vue&type=script&lang=js&"
export * from "./TeacherLevelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4656ae4f",
  null
  
)

export default component.exports